/**
 * Erkennt, ob ein Besucher Deutsch oder Englisch schreibt — ohne Modell, ohne
 * Bibliothek: Funktionswörter zählen. Kurze oder mehrdeutige Texte („Hallo",
 * „Smart Locks?") ergeben `null`, und dann bleibt die Sprache, wie sie war.
 * Nur ein klarer Vorsprung wechselt sie; ein deutscher Besucher, der einen
 * englischen Produktnamen tippt, bleibt Deutsch.
 */
const DE = new Set([
  'der',
  'die',
  'das',
  'und',
  'ist',
  'ich',
  'nicht',
  'ein',
  'eine',
  'mir',
  'mich',
  'du',
  'wie',
  'was',
  'wo',
  'kann',
  'kannst',
  'gibt',
  'es',
  'sie',
  'wir',
  'ihr',
  'mit',
  'für',
  'auf',
  'zu',
  'von',
  'bitte',
  'danke',
  'hallo',
  'erzähl',
  'erzähle',
  'zeig',
  'zeige',
  'welche',
  'welcher',
  'wer',
  'warum',
  'noch',
  'auch',
  'hier',
  'dem',
  'den',
  'des',
  'im',
  'am',
  'bin',
  'sind',
  'habe',
  'hast',
  'haben',
  'möchte',
  'will',
  'gerne',
  'mehr',
  'über',
  'oder',
  'aber',
  'wenn',
  'dann',
])
const EN = new Set([
  'the',
  'and',
  'is',
  'are',
  'i',
  'you',
  'not',
  'a',
  'an',
  'me',
  'my',
  'how',
  'what',
  'where',
  'can',
  'could',
  'do',
  'does',
  'it',
  'we',
  'they',
  'with',
  'for',
  'on',
  'to',
  'of',
  'please',
  'thanks',
  'thank',
  'hello',
  'hi',
  'tell',
  'show',
  'which',
  'who',
  'why',
  'more',
  'about',
  'this',
  'that',
  'there',
  'here',
  'have',
  'has',
  'would',
  'like',
  'want',
  'or',
  'but',
  'if',
  'then',
  'your',
  'from',
  'us',
  'in',
  'at',
])

export type DetectedLanguage = 'de' | 'en'

export function detectLanguage(text: string): DetectedLanguage | null {
  const woerter = text
    .toLowerCase()
    .replace(/[^\p{L}\p{N}']+/gu, ' ')
    .split(' ')
    .filter(Boolean)
  if (woerter.length === 0) return null
  let de = 0
  let en = 0
  for (const w of woerter) {
    if (DE.has(w)) de++
    if (EN.has(w)) en++
  }
  // Umlaute und ß gibt es im Englischen nicht — ein starkes Zeichen für Deutsch.
  if (/[äöüß]/i.test(text)) de += 2
  if (de === en) return null
  const vorsprung = Math.abs(de - en)
  const gesamt = de + en
  // Mindestens zwei Treffer und ein klarer Vorsprung, sonst bleibt es offen.
  if (gesamt < 2 || vorsprung < Math.max(1, Math.ceil(gesamt / 3))) return null
  return de > en ? 'de' : 'en'
}
